import { Api, DigitalOrdersApi, ConfigApi, AutomationApi } from '../api';

/**
 * The environment is a place where services and shared dependencies between
 * models live.  They are made available to every model via dependency injection.
 */
export class MobxEnvironment {
  api: Api;
  digitalOrdersApi: DigitalOrdersApi;
  configApi: ConfigApi;
  automationApi: AutomationApi;
}
